import { useLinkPressedCallback } from '@zenbusiness/application-commons-clickstream';
import Caption from '@zenbusiness/common-components/Caption';
import SharedAsset from '@zenbusiness/common-components/SharedAsset';
import Text from '@zenbusiness/common-components/Text';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import { styled } from '@mui/material/styles';

import { buildCartUrl } from '#client/utils/urls';

const StyledCardRoot = styled(Card)(({ theme }) => ({
  width: '100%',
  '& .MuiLink-root': {
    '&:hover': {
      textDecoration: 'none'
    }
  },
  borderRadius: theme.spacing(2)
}));

const StyledCardContent = styled(CardContent)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-around',
  alignItems: 'center',
  marginBottom: 0,
  padding: theme.spacing(4, 0),
  '& .MuiTypography-h2': {
    ...theme.typography.title_large
  }
}));

const StyledCardActions = styled(CardActions)(({ theme }) => ({
  justifyContent: 'space-between',
  flexDirection: 'column-reverse',
  minHeight: theme.spacing(12),
  padding: theme.spacing(3, 4)
}));

const StyledCardActionArea = styled(CardActionArea)(() => ({
  display: 'flex',
  flexDirection: 'column',
  marginLeft: 0
}));

const StyledSharedAssetCardIconLarge = styled(SharedAsset)(({ theme }) => ({
  display: 'block',
  margin: 'auto',
  paddingTop: theme.spacing(6),
  paddingBottom: theme.spacing(2.5)
}));

const StyledButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  paddingBottom: theme.spacing(2.5),
  paddingTop: theme.spacing(2.5),
  display: 'block',
  lineHeight: theme.spacing(3),
  fontWeight: 700,
  position: 'static',
  '&:before': {
    content: '""',
    display: 'block',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%'
  }
}));

const DomainPurchaseCard = ({ businessEntityUuid }) => {
  const domainUrl = buildCartUrl('domain_name_reg', { businessEntityUuid });
  const handleClick = useLinkPressedCallback({
    elementName: 'find_domain_names',
    elementText: 'Find Domain Names',
    linkDestination: domainUrl,
    pageCategory: 'dashboard',
    pageSection: 'growth',
    screenName: 'domains_page'
  });
  return (
    <StyledCardRoot variant="outlined">
      <StyledCardActionArea component={Box}>
        <StyledSharedAssetCardIconLarge src="/icon/misc/domain_add256.svg" width={80} alt="" />
        <StyledCardContent>
          <Text size="lg" align="center">Search for New Domains</Text>
          <Caption size="lg" align="center">Find additional names for your business</Caption>
        </StyledCardContent>
        <StyledCardActions disableSpacing>
          <StyledButton
            variant="contained"
            color="primary"
            href={domainUrl}
            onClick={handleClick}
          >
            Find Domain Names
          </StyledButton>
        </StyledCardActions>
      </StyledCardActionArea>
    </StyledCardRoot>
  );
};

DomainPurchaseCard.propTypes = {
  businessEntityUuid: PropTypes.string.isRequired
};

export default DomainPurchaseCard;
